/**
 * @file echart 按需引入，优化页面性能
 */

 import echarts from 'echarts/lib/echarts';

 // 按需加载的模块
 import 'echarts/lib/chart/line';
 import 'echarts/lib/component/legend';
 // import 'echarts/lib/component/title'
 import 'echarts/lib/component/tooltip';
 
 export default echarts;